<template>
  <div>
    <b-row class="match-height">
      <!-- ป้าย VMS -->
      <b-col
        xl="6"
        lg="6"
        md="6"
        sm="12"
      >
        <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: 500px; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
          <div>
            <b-img
              class="mb-1 mr-1"
              src="@/assets/images/icons/iconvms.svg"
            />
            <span style="font-size: 20px;">ป้าย VMS</span>
          </div>
          <b-row>
            <b-col
              cols="12"
            >
              <div style="text-align:center;">
                <iframe
                  id="vms"
                  width="600"
                  height="400"
                  allowfullscreen
                  frameBorder="0"
                  :src="video_vms"
                />
              </div>
            </b-col>
          </b-row>
        </b-card>

      </b-col>
      <b-col
        xl="6"
        lg="6"
        md="6"
        sm="12"
      >
        <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: 500px; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
          <div>
            <b-img
              class="mb-1 mr-1"
              src="@/assets/images/icons/cctv.svg"
            />
            <span style="font-size: 20px;">กล้อง</span>
          </div>
          <b-row>
            <b-col
              cols="12"
            >
              <div style="text-align:center;">
                <iframe
                  scrolling="no"
                  width="600"
                  height="400"
                  allowfullscreen
                  frameBorder="0"
                  :src="cam1"
                />
              </div>
            </b-col>
          </b-row>
        </b-card>

      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BImg, BCard,
  // BButton, BBadge,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,

    // BButton,
    // BBadge,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      cam: '',
      video_vms: '',
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getVideo()
    this.interval = setInterval(() => {
      this.getVideo()
    }, 300000)
  },
  methods: {
    getVideo() {
      axios
        .post('/getMarkerVMSDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.status = response.data[0].vms_connect
          this.video_vms = response.data[0].desktop_screen
          this.cam1 = response.data[0].traffic_sign_cam1
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style scoped>
video[poster]{
  object-fit: cover;
}.center{
 margin: 0 auto;
 width: 300px;
 display: block;
}
  </style>
